import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { get } from "lodash";

function AddEnvironment(props) {
  const navigate = useHistory();
  const [formData, setName] = useState({
    EnvironmentName: "",
    PrefabName: "",
    PrefabUrl: "",
  });

  const [AnimatorList, setAnimatorList] = useState([]);
  const [AnimatorImgPreview, setAnimatorImgPreview] = React.useState("");
  const [AnimatorId, setAnimatorId] = React.useState("");
  const [EnvironmentImgPreview, setEnvironmentImgPreview] = useState("");
  const [EnvironmentImage, setEnvironmentImage] = useState();

  useEffect(() => {
    LoadAnimators();
  }, []);

  const LoadAnimators = () => {
    setAnimatorId("");
    var img = document.getElementById("animImgPreview");
    img.style.visibility = "hidden";
    img.style.width = "0px";
    img.style.height = "0px";

    var authOptions = {
      method: "get",
      url: `${process.env.REACT_APP_API_URL}/GetAnimatorList`,
    };

    axios(authOptions).then((res) => {
      setAnimatorList(res.data);
    });
  };

  const AddEnvironmentSubmit = async (e) => {
    e.preventDefault();
    let formDataSet = new FormData();
    //formdata object
    if (formData.EnvironmentName === "" || formData.PrefabName === "" || formData.PrefabUrl === "" || !EnvironmentImage) {
      // if (AnimatorId === "") {
      //   Swal.fire({
      //     title: "Error",
      //     text: "Please select at least one animator.",
      //     icon: "error",
      //     confirmButtonText: "Ok",
      //   });
      // }

      if (formData.EnvironmentName === "") {
        Swal.fire({
          title: "Error",
          text: "Environment Name is Required",
          icon: "error",
          confirmButtonText: "Ok",
        });
      }

      if (formData.PrefabName === "") {
        Swal.fire({
          title: "Error",
          text: "Prefab Name is Required",
          icon: "error",
          confirmButtonText: "Ok",
        });
      }

      if (formData.PrefabUrl === "") {
        Swal.fire({
          title: "Error",
          text: "Prefab URL is Required",
          icon: "error",
          confirmButtonText: "Ok",
        });
      }

      if (!EnvironmentImage) {
        Swal.fire({
          title: "Error",
          text: "Environment Image is Required",
          icon: "error",
          confirmButtonText: "Ok",
        });
      }
    } else {
      formDataSet.append("Environment_Name", formData.EnvironmentName);
      formDataSet.append("Environment_Prefab_Name", formData.PrefabName);
      formDataSet.append("Environment_URL", formData.PrefabUrl);
      formDataSet.append("EnvironmentImage", EnvironmentImage);
      formDataSet.append("Animator_Id", AnimatorId === "" ? 0 : AnimatorId);

      let token = null;
      try {
        const raw = localStorage.getItem("state");
        if (raw) {
          const state = JSON.parse(raw);
          token = state.auth?.token;
        }
      } catch (e) {
        console.error("Token parsing failed", e);
      }

      var authOptions = {
        method: "post",
        url: `${process.env.REACT_APP_API_URL}/AddEnvironment`,
        data: formDataSet,
        headers: { "content-type": "multipart/form-data", ...(token && { "Authorization": `Bearer ${token}` }) },
      };
      axios(authOptions)
        .then((res) => {
          if (res.data.ExpResult) {
            Swal.fire({
              title: "Failed",
              text: res.data.ExpResult,
              icon: "error",
              confirmButtonText: "Ok",
            });
          } else if (res.data.SuccessResult) {
            Swal.fire({
              title: "Success",
              text: res.data.SuccessResult,
              icon: "success",
              confirmButtonText: "Ok",
            }).then(function () {
              navigate.push("/EnvironmentList")
            });
          } else {
            Swal.fire({
              title: "Error",
              text: "An error occured!",
              icon: "error",
              confirmButtonText: "Ok",
            });
          }
        })
        .catch((error) => {
          //console.log("error occur", error);
          Swal.fire({
            title: "Error Occured",
            text: "Something went wrong!",
            icon: "error",
            confirmButtonText: "Ok",
          });
        });
    }
  };

  const handleChange = (e) => {
    setName({ ...formData, [e.target.name]: e.target.value });
  };

  const handleEnvironemtImgChange = (e) => {
    setEnvironmentImage(get(e, "target.files[0]"));
    setEnvironmentImgPreview(URL.createObjectURL(e.target.files[0]));
  }

  const handleChangeAnimator = (event) => {
    let anim_id = event.target.value
    if (anim_id != "") {
      setAnimatorId(anim_id);
      var imagepath = `${process.env.REACT_APP_API_URL}/GetAnimatorImageById?AnimatorId=` + anim_id;
      setAnimatorImgPreview(imagepath);
      var img = document.getElementById("animImgPreview");
      img.style.visibility = "visible";
      img.style.width = "100%";
      img.style.height = "auto";
    } else {
      emptyAnimator();
    }
  };

  function emptyAnimator() {
    setAnimatorId("");
    var img = document.getElementById("animImgPreview");
    img.style.visibility = "hidden";
    img.style.width = "0px";
    img.style.height = "0px";
  }

  /* Function to redirect in Environment List Page */
  const BackFunc = () => {
    navigate.push("/EnvironmentList")
  };

  return (
    <>
      <div className="page-content-wrapper">
        <div className="page-content">
          <div className="page-bar">
            <div className="page-title-breadcrumb">
              <div className=" pull-left">
                <div className="page-title my-0">Add Environment</div>
              </div>
              <div className=" pull-right">
                <button
                  type="submit"
                  className="btn d-inline-block"
                  style={{ backgroundColor: "#1e2b38", color: "#FFF", border: "1px solid #1e2b38" }}
                  onClick={BackFunc}
                >
                  {" "}
                  <i className="fa fa-arrow-left" aria-hidden="true"></i>
                </button>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-2 col-sm-2"></div>
            <div className="col-md-8 col-sm-8">
              <div className="card card-box">
                <div className="card-head">
                  <header>Add Environment</header>
                </div>
                <div className="card-body " id="bar-parent1">
                  <form
                    className="register-form"
                    id="login-form"
                    onSubmit={AddEnvironmentSubmit}
                  >

                    {/* Environment Name */}
                    <div className="form-group row required">
                      <label
                        htmlFor="EnvironmentName"
                        className="col-sm-3 control-label"
                      >
                        {" "}
                        Environment Name
                      </label>
                      <div className="col-sm-9">
                        <input
                          type="text"
                          value={formData.EnvironmentName}
                          onChange={handleChange}
                          name="EnvironmentName"
                          className="form-control"
                          id="EnvironmentName"
                          placeholder="Environment Name"
                        />
                      </div>
                    </div>

                    {/* Environment Prefab Name */}
                    <div className="form-group row required">
                      <label
                        htmlFor="PrefabName"
                        className="col-sm-3 control-label"
                      >
                        {" "}
                        Prefab Name
                      </label>
                      <div className="col-sm-9">
                        <input
                          type="text"
                          value={formData.PrefabName}
                          onChange={handleChange}
                          name="PrefabName"
                          className="form-control"
                          id="PrefabName"
                          placeholder="Prefab Name"
                        />
                      </div>
                    </div>

                    {/* Environment Prefab URL */}
                    <div className="form-group row required">
                      <label
                        htmlFor="PrefabUrl"
                        className="col-sm-3 control-label"
                      >
                        {" "}
                        Prefab URL
                      </label>
                      <div className="col-sm-9">
                        <input
                          type="text"
                          value={formData.PrefabUrl}
                          onChange={handleChange}
                          name="PrefabUrl"
                          className="form-control"
                          id="PrefabUrl"
                          placeholder="Prefab URL"
                        />
                      </div>
                    </div>

                    {/* Environment Image */}
                    <div className="form-group row required">
                      <label
                        htmlFor="EnvironmentImg"
                        className="col-sm-3 control-label"
                      >
                        {" "}
                        Environment Image
                      </label>
                      <div className="col-sm-9">
                        <input
                          type="file"
                          name="EnvironmentImg"
                          onChange={handleEnvironemtImgChange}
                          className="form-control"
                          accept="image/*"
                          style={{ "lineHeight": "1.8" }}
                          id="EnvironmentImg"
                        />
                      </div>
                    </div>

                    {/* Environment Image Preview */}
                    <div className="form-group row">
                      <label
                        className="col-sm-3 control-label"
                      >
                        {" "}
                      </label>
                      <div className="col-sm-9 d-flex justify-content-center">
                        <a href={EnvironmentImgPreview} target="_blank" rel="noopener">
                          <img
                            src={EnvironmentImgPreview}
                            style={{
                              width: "150px",
                              maxHeight: "150px",
                              objectFit: "contain",
                            }}
                          />
                        </a>

                      </div>
                    </div>

                    {/* Choose Animator */}
                    <div className="form-group row required">
                      <label
                        htmlFor="animator"
                        className="col-sm-3 control-label"
                      >
                        Animator
                      </label>
                      <div className="col-sm-4">
                        <select
                          id="animator"
                          className="form-control select2"
                          onChange={handleChangeAnimator}
                        >
                          <option value="">--Select--</option>
                          {AnimatorList.map((result, i) => {
                            return (
                              <option value={result.id} key={result.id}>
                                {result.animator_Name}
                              </option>
                            );
                          })}
                        </select>
                      </div>

                      <div className="col-sm-5">
                        <div className="col-sm-12 d-flex justify-content-center">
                          <a href={AnimatorImgPreview} target="_blank" rel="noopener" className="prevImgContainer">
                            <img
                              id="animImgPreview"
                              className="previewImg"
                              src={AnimatorImgPreview}
                              style={{
                                objectFit: "contain",
                                visibility: "hidden"
                              }}
                            />
                          </a>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-12 text-end">
                        <button
                          type="submit"
                          className="btn d-inline-block"
                          style={{ backgroundColor: "#1e2b38", color: "#FFF", border: "1px solid #1e2b38" }}
                        >
                          Submit
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-3"></div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddEnvironment;
